/**
 * Symbols for an injection service to use when binding by identifiers.
 */
export const InjectionSymbols = {
    LOGGER: "Logger",
};
